import apiClient from './api';

export const getDomains = async () => {
  try {
    const response = await apiClient.get('/api/Domain');
   
    return response.data;
  } catch {

    // throw new Error("Erreur de recuperation des domains", error);
  }
};

// Récupération d'un domaine par ID
export const getDomainById = async (domainId) => {
  try {
      const response = await apiClient.get(`/api/Domain/${domainId}`);
      return response.data;
  } catch  {
      // console.error("Error fetching domain by ID:", error);
    //   throw new Error("Error fetching domain by ID:", error);
  }
};


// Creation d'un domain
export const createDomain = async (domainData) => {
  try {
      const response = await apiClient.post('/api/Domain', domainData, {
          headers: {
              'Content-Type': 'multipart/form-data', // Important for file uploads
          },
      });
      return response.data;
  } catch  {
      // console.error("Error creating domain:", error);
    //   throw new Error("Error creating domain:", error);
  }
};

// Modification d'un domain
export const updateDomain = async (id, domainData) => {
  try {
      const response = await apiClient.put(`/api/Domain/${id}`, domainData, {
          headers: {
              'Content-Type': 'multipart/form-data', // Important for file uploads
          },
      });
      return response.data;
  } catch (error) {
      // console.error("Error updating domain:", error);
      throw new Error("Error DE modification du domain:", error);
  }
};

export const getDomainManagers = async (domainId) => {
  try {
      const response = await apiClient.get(`/api/DomainUser/${domainId}/managers`); // Appel à l'API
      return response.data;
  } catch (error) {
      throw new Error("Erreur", error);
  }
};


export const getTotalDomainCount = async () => {
  try {
      const response = await apiClient.get('/api/Domain/count');
      return response.data;
  } catch (error) {
      // console.error("Erreur compteur domaines :", error);
      throw error("Erreur compteur domaines :", error);
  }
};

// Supprimer un domaine par ID
export const deleteDomain = async (domainId) => {
  try {
      // Effectuer la requête DELETE pour supprimer le domaine
      const response = await apiClient.delete(`/api/Domain/${domainId}`);

      if (response.status === 204) {
          // Si la suppression est réussie, renvoyer true
          return true;
      } else {
          // Si la réponse est autre que 204 (No Content), gérer le cas d'erreur
          // console.error('Erreur lors de la suppression du domaine:', response);
          return false;
      }
  } catch (error) {
      // Gérer les erreurs de la requête (par exemple, une erreur réseau)
      // console.error("Erreur de connexion ou problème de serveur:", error);
      return error;
  }
};

